/**
 * Public dispensary menu fetcher + types. Lifted from
 * `apps/customer-web/src/lib/{fetch-dispensary-menu,dispensary-menu-types}.ts`
 * — types and fetcher consolidated since they always travel together.
 *
 * Endpoint is unauthenticated; `baseUrl` parameter handles the per-app
 * env layer (Vite for web, Expo for mobile).
 */
import { dispensaryMenuUrl } from "./url-builders";
export class DispensaryMenuNotFoundError extends Error {
    constructor() {
        super("dispensary_not_found");
        this.name = "DispensaryMenuNotFoundError";
    }
}
/** Non-404 HTTP from menu endpoint (e.g. 502 when Vite proxy cannot reach the API). */
export class DispensaryMenuHttpError extends Error {
    status;
    /** From JSON body when API returns `hint` (e.g. migration 503). */
    apiHint;
    constructor(status, apiHint) {
        super(`menu_http_${status}`);
        this.name = "DispensaryMenuHttpError";
        this.status = status;
        this.apiHint = apiHint;
    }
}
export async function fetchDispensaryMenu(baseUrl, slug) {
    const url = dispensaryMenuUrl(baseUrl, slug);
    let res;
    try {
        res = await fetch(url);
    }
    catch {
        throw new TypeError("fetch_failed");
    }
    if (res.status === 404) {
        throw new DispensaryMenuNotFoundError();
    }
    if (!res.ok) {
        let apiHint;
        try {
            const j = (await res.json());
            if (typeof j.hint === "string" && j.hint.length > 0) {
                apiHint = j.hint;
            }
        }
        catch {
            /* ignore non-JSON error bodies */
        }
        throw new DispensaryMenuHttpError(res.status, apiHint);
    }
    try {
        return (await res.json());
    }
    catch {
        throw new SyntaxError("menu_json");
    }
}
//# sourceMappingURL=dispensary-menu.js.map